import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { UserService } from '../shared/providers/auth/user.service';
import { CommonModule, DatePipe } from '@angular/common';
import { UserContextService } from '../shared/providers/context/user-context.service';
import { EmailComposer, OpenOptions } from 'capacitor-email-composer';
import { environment } from '../../environments/environment';
import { ImgViewerComponent } from '../shared/components/img-viewer/imgviewer.component';
import { DeviceServices } from '../shared/providers/device/device.service';

@Component({
  selector: 'dysfonctionnement',
  templateUrl: 'dysfonctionnement.page.html',
  styleUrls: ['./dysfonctionnement.page.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonItem,
    IonLabel,
    IonNote,
    ReactiveFormsModule,
    CommonModule,
    IonTextarea,
  ],
})
export class DysfonctionnementPage implements OnInit {
  @Input()
  public photoInfo: {
    base64: string;
  };

  /**
   * moment de l'entrée dans la page formaté
   */
  dysfonctionDate: string;

  /**
   * Limite de taille du commentaire
   */
  readonly maxTextLength = 1000;

  /**
   * Screenshot original
   */
  originScreenshot: string;

  dysfonctionnementForm: FormGroup;

  /**
   * Nom du menu sur lequel est l'utilisateur
   */
  menuName: string;

  /**
   * Nom de la page sur laquel est l'utilisateur
   */
  pageName: string;

  /**
   * Contexte ou déclaration est faite
   */
  contextInfos: { key: string; value: string }[];

  constructor(
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    private userContextService: UserContextService,
    private userService: UserService,
    private deviceService: DeviceServices
  ) {}

  ngOnInit(): void {
    this.dysfonctionDate = this.datePipe.transform(new Date(), 'dd/MM/YYYY HH:mm:ss');
    this.originScreenshot = this.photoInfo ? this.photoInfo.base64 : null;
    this.dysfonctionnementForm = new FormGroup({
      dysfonctionnementText: new FormControl('', [Validators.required]),
    });
    this.contextInfos = [];
    let contextProperties = this.userContextService.getContextProperties();
    if (contextProperties) {
      contextProperties.forEach((v, k) => {
        this.contextInfos.push({ key: k, value: v });
      });
      this.menuName = this.userContextService.menuSelected;
      this.pageName = this.userContextService.actualPage;
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  dysTextLength() {
    return this.dysfonctionnementForm.get('dysfonctionnementText').value.length;
  }

  async openImage(originScreenshot: string) {
    let modalGft = await this.modalCtrl.create({
      component: ImgViewerComponent,
      componentProps: {
        picture: { contenu: originScreenshot },
      },
    });
    await modalGft.present();
  }

  /**
   * Créé un mail en initialisant les pièces jointes et l'objet, et lance l'application de mail du smartphone
   *
   */
  createEmail() {
    // Creation du contenu du mail au format HTML
    let body = `${this.dysfonctionnementForm.get('dysfonctionnementText').value}`;
    if (this.contextInfos) {
      body = `${body}<br />`;
      body = `${body}-----------------------------------------------------<br />`;
      body = `${body}NE RIEN INSCRIRE / MODIFIER EN DESSOUS DE CETTE LIGNE<br />`;
      body = `${body}-----------------------------------------------------<br />`;
      body = `${body}<ul>`;
      body = `${body} <li> Horodate création dysfonctionnement : ${this.dysfonctionDate}</li>`;
      body = `${body} <li> Version D@cTech : ${this.deviceService.getInfos().device_app_version} - ${
        environment.name
      }</li>`;
      body = `${body} <li> Menu actuel : ${this.menuName}</li>`;
      body = `${body} <li> Vue actuelle : ${this.pageName}</li>`;
      this.contextInfos.forEach(({ key, value }) => {
        body = `${body} <li> ${key} : ${value}</li>`;
      });
      body = `${body} <li> Utilisateur : ${this.userService.getDkCodeRessource()} -  ${this.userService.getCompleteName()} </li>`;
      body = `${body} <li> Marque - Modèle téléphone: ${
        this.deviceService.getInfos().device_manufacturer
      } - ${this.deviceService.getInfos().device_model}`;
      body = `${body}</ul>`;
    }
    body = `<p>${body}</p>`;

    // this.emailComposer.addAlias('gmail', 'com.google.android.gm');
    let email: OpenOptions = {
      to: ['oasis@dalkia.fr'],
      cc: [this.userService.getEmail()] || [],
      attachments: [
        {
          type: 'base64',
          path: this.originScreenshot,
          name: 'capture.png',
        },
      ],
      subject: "Demande de création d'incident D@cTech",
      body: body,
      isHtml: true,
    };
    EmailComposer.open(email).then(() => {
      this.closeModal();
    });
  }
}
